<template>
  <li
    :class="ns.b()"
    data-test-name="menu-item-group"
    data-test-variant=""
    data-test-state=""
  >
    <div :class="ns.e('title')">
      <template v-if="!$slots.title">{{ title }}</template>
      <slot v-else name="title" />
    </div>
    <ul>
      <slot />
    </ul>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@bigin/hooks'
import { menuItemGroupProps } from './menu-item-group'

const COMPONENT_NAME = 'BMenuItemGroup'

export default defineComponent({
  name: COMPONENT_NAME,

  props: menuItemGroupProps,

  setup() {
    const ns = useNamespace('menu-item-group')

    return {
      ns,
    }
  },
})
</script>
